import {
  CLIENT_SEARCH_LIST_REQUEST,
  CLIENT_SEARCH_LIST_SUCCESS,
  CLIENT_SEARCH_LIST_FAILURE
} from '../../actions/clientActions'

export default function reducer(
  state = {
    isFetching: false,
    isDeleting: false,
    data: [],
    errors: {},
    needRefresh: false,
    clientData: {},
    selected: {}
  },
  action
) {
  switch (action.type) {
    case CLIENT_SEARCH_LIST_REQUEST:
      return Object.assign({}, state, {
        isFetching: true,
        needRefresh: false
      })

    case CLIENT_SEARCH_LIST_SUCCESS:
      return Object.assign({}, state, {
        isFetching: false,
        data: action.data
      })

    case CLIENT_SEARCH_LIST_FAILURE:
      return Object.assign({}, state, {
        isFetching: false,
        errors: action.data
      })

    default:
      return state
  }
}
